import type { FC } from 'react'
import { useAppNavigation } from '#app/navigation/useAppNavigation'
import type { TruckConfiguration } from '#app/store/slices/configurationSlice'
import { HeaderDropdownEntry } from '#features/AppLayout/Header/HeaderTabs'
import { makeConfigurationLocation } from '#pages/Configuration/components/ConfigurationNavigation'
import { useDenominationDisplayData } from '#pages/Configuration/components/useDenominationDisplayData'

export const ConfigurationHeaderDropdownLink: FC<{ configuration: TruckConfiguration }> = ({ configuration }) => {
  const { navigate } = useAppNavigation()
  const { configurationTitle } = useDenominationDisplayData(configuration)
  return (
    <HeaderDropdownEntry
      onClick={() => {
        navigate(makeConfigurationLocation(configuration))
      }}
    >
      {configurationTitle}
    </HeaderDropdownEntry>
  )
}
